import Vue from "vue";
import axios from "axios";
import App from "./App";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import router from "./router/router.js";
import store from "./store";
import Notifications from "./components/Common/Notification";
import Breadcrumb from "./components/Common/Breadcrumb.vue";
import RefreshButton from "./components/Common/RefreshButton.vue";
import Colxx from "./components/Common/Colxx";
import vuePerfectScrollbar from "vue-perfect-scrollbar";
import contentmenu from "v-contextmenu";
import VueLineClamp from "vue-line-clamp";
import VueScrollTo from "vue-scrollto";
import VueCookie from "vue-cookie";
import VSelect from "vue-select";
import VuePerfectPrint from "vue-perfect-print";
// css
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "../src/assets/css/vendor/dropzone.min.css";
import "../src/assets/css/ahadi.css";
import "../src/assets/css/animate.css";
import "../src/assets/fonts/simple-line-icons/css/simple-line-icons.css";
import "../src/assets/fonts/iconsmind/style.css";
import "../src/assets/fonts/iconsmind-s/css/iconsminds.css";
import "../src/assets/css/vendor/bootstrap.rtl.only.min.css";
import "video.js/dist/video-js.css";
import "../src/assets/css/sass/themes/piaf.light.blueolympic.scss";
import "leaflet/dist/leaflet.css";
import 'vue-select/dist/vue-select.css';
//
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(require("vue-shortkey"));
Vue.use(contentmenu);
Vue.use(VueScrollTo);
Vue.use(VueLineClamp, { importCss: true });
Vue.use(VueCookie);
Vue.use(router);
Vue.use(VuePerfectPrint);
Vue.component("piaf-breadcrumb", Breadcrumb);
Vue.component("b-refresh-button", RefreshButton);
Vue.component("b-colxx", Colxx);
Vue.component("vue-perfect-scrollbar", vuePerfectScrollbar);
Vue.component("v-select", VSelect);

// axios.defaults.baseURL = "http://188.253.3.236";
axios.defaults.baseURL = "https://backend.ayandehsazan.ir";
// axios.defaults.baseURL = 'http://192.168.248.192:8000';

Vue.config.productionTip = false;

export default new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
